var map = {
	"./icon-arrow.svg": 1089,
	"./icon-close.svg": 829,
	"./icon-copy.svg": 4171,
	"./icon-lfg.svg": 4012,
	"./icon-ok.svg": 5686,
	"./icon-refresh.svg": 2037,
	"./icon-telegram.svg": 5810,
	"./icon-user.svg": 8639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7933;